"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ExtendableError extends Error {
    constructor(message, { isRetryable = false } = {}) {
        super(message);
        this.message = message;
        this.name = this.constructor.name;
        this.isRetryable = isRetryable;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            this.stack = new Error(message).stack;
        }
    }
}
exports.default = ExtendableError;
